import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import './index.less';
import { initEditor } from './config/config';

interface TinymceProps {
  height?:string;
  value?: string;
  changeValue?: (value: string) => void;
  onInit?: () => void;
}

const prefix = 'Tinymce';
const Tinymce= forwardRef((props: TinymceProps,ref) => {
  const {value,changeValue,onInit,height='800px'}=props;
  const tinymceId=useRef<any>("tinymce-" + +new Date() + ((Math.random() * 1000).toFixed(0) + ""));
  const tinymceContainer = useRef<any>(null);
  console.log('tinymce render',value)
  useImperativeHandle(ref, () => ({
    tinymceContainer,
    addToolBarPlugin,
    insertContent
  }))
  const initTinymce=()=> {

    window.tinymce?.init({
      selector: `#${tinymceId.current}`,
      convert_urls: false,
      init_instance_callback: (editor:any) => {
        if (value) {
          // 如果有初始值，则设置编辑器的内容为初始值
        
          editor.setContent(value)
        }
        // 监听编辑器内容的变化
        editor.on("NodeChange Change KeyUp  SetContent", (event:any) => {
          // 通过 input 事件将编辑器的内容传递给父组件
          changeValue && changeValue(editor.getContent());

        });
      },
      setup(editor:any) {

        tinymceContainer.current = editor;
        onInit && onInit();
      },
      ...initEditor,

      height:height
    });
  }
  /**
   * 添加自定义插件
   * @param name 
   * @param config 
   * @returns 
   */
  const addToolBarPlugin = useCallback((name:string,config:{icon:string,tooltip:string,onAction:()=>void}) => {
    if(tinymceContainer.current==null) return;
    console.log('addToolBarPlugin',tinymceContainer.current.PluginManager);
    
      tinymceContainer.current.ui.registry.addButton(name, config);

    
  },[])
  /**
   * 插入内容
   * @param content 
   * @returns 
   */
  const insertContent = useCallback((content:string) => {
    if(tinymceContainer.current==null) return;
    tinymceContainer.current.insertContent(content);
  },[])
  useEffect(()=>{
    console.log('init tinymce');
    initTinymce();
    return ()=>{
      console.log('destroy tinymce');
      tinymceContainer.current?.destroy();
    }
  },[])
  return (
    <div className='tinymce-container'>
      <textarea id={tinymceId.current} className={'tinymce-textarea'}></textarea>
    </div>
  );
})
Tinymce.displayName = 'Tinymce';
export default React.memo(Tinymce);
